import { render } from "./AnalisisDeInversionesView.vue?vue&type=template&id=1a2ee7d5&scoped=true"
import script from "./AnalisisDeInversionesView.vue?vue&type=script&lang=js"
export * from "./AnalisisDeInversionesView.vue?vue&type=script&lang=js"

import "./AnalisisDeInversionesView.vue?vue&type=style&index=0&id=1a2ee7d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2ee7d5"]])

export default __exports__